<template>
  <v-card class="pa-5" outlined>
    <div class="d-flex justify-space-between align-center mb-2">
      <h3>Acessos por dispositivo</h3>
    </div>
    <apexchart class="mt-5" type="donut" height="350" :options="chartData.options" :series="chartData.series"></apexchart>
  </v-card>
</template>

<script>
export default {
  props: ['link'],
  computed: {
    chartData () {
      const { labels, values, colors } = this.devices

      return {
        series: values,
        labels,
        options: {
          chart: {
            height: 300,
            type: 'donut',
            animations: {
              enabled: false
            }
          },
          dataLabels: {
            enabled: true
          },
          labels,
          legend: {
            position: 'bottom'
          },
          colors,
          tooltip: {
            custom: ({ series, seriesIndex, w }) => {
              return `
                <div class="arrow_box pa-3">
                  <span>${w.globals.labels[seriesIndex]}: ${this.$options.filters.number(series[seriesIndex])}</span>
                </div>
              `
            }
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    show: true
                  },
                  value: {
                    show: true
                  },
                  total: {
                    show: true,
                    label: 'Total',
                    formatter: ({ globals }) => {
                      return this.$options.filters.number(globals.series.reduce((data, item) => data + item, 0))
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    devices () {
      const data = {
        labels: [],
        values: [],
        colors: []
      }

      if (!this.link) {
        return data
      }

      const devices = {
        mobile: 0,
        desktop: 0
      }

      this.link.clicks.forEach(click => {
        devices.mobile += click.ios || 0
        devices.mobile += click.android || 0
        devices.desktop += click.mac || 0
        devices.desktop += click.linux || 0
        devices.desktop += click.windows || 0
      })

      if (devices.mobile) {
        data.labels.push('Mobile')
        data.values.push(devices.mobile)
        data.colors.push('#00188f')
      }
      
      if (devices.desktop) {
        data.labels.push('Desktop')
        data.values.push(devices.desktop)
        data.colors.push('#0078d4')
      }

      return data
    }
  }
}
</script>

<style lang="scss" scoped>

</style>